import Immutable from 'immutable';
import * as types from './PersonalLogin.types';

const initialState = {
    form: {
        email1: '',
        password1: '',
        email2: '',
        password2: '',
        name: '',
        email: '',
        confirmEmail: '',
        username: '',
        password: '',
        confirmPassword: '',
        phone: '',
    },
    isLogging: false,
    loginType: null,
    redirect: false,
    isSignUp: false,
    signingUp: false,
    signUpType: null,
    loggedType: null,
}

export default function (state = initialState, action) {
    state = Immutable.fromJS(state);
    switch (action.type) {
        case types.SET_FIELD:
            return state.setIn(['form', action.payload.name], action.payload.value).toJS();

        case types.LOGIN:
            return state.setIn(['isLogging'], true)
                .setIn(['loginType'], action.payload)
                .toJS();

        case types.LOGIN_SUCCESS:
            return state.setIn(['isLogging'], false)
                .setIn(['form'], {
                    email1: '',
                    password1: '',
                    email2: '',
                    password2: '',
                    name: '',
                    email: '',
                    username: '',
                    password: '',
                    confirmPassword: '',
                    phone: '',
                    signUpType: null,
                })
                .setIn(['loginType'], null)
                .toJS();

        case types.LOGIN_ERROR:
            return state.setIn(['isLogging'], false)
                .setIn(['loginType'], null)
                .toJS();

        case types.SIGN_UP:
            return state.setIn(['signingUp'], true).toJS();

        case types.SIGN_UP_SUCCESS:
            return state.setIn(['form'],
                {
                    email1: '',
                    password1: '',
                    email2: '',
                    password2: '',
                    name: '',
                    email: '',
                    username: '',
                    password: '',
                    confirmPassword: '',
                    phone: '',
                    signUpType: null,
                })
                .toJS();

        case types.SIGN_UP_ERROR:
            return state.setIn(['signingUp'], false).toJS();

        case types.SET_REDIRECT:
            return state.setIn(['redirect'], action.payload).toJS();

        case types.SET_SIGN_UP:
            return state.setIn(['isSignUp'], action.payload != null)
                .setIn(['signUpType'], action.payload)
                .toJS();

        case types.SET_LOGGED_TYPE:
            return state.setIn(['loggedType'], action.payload).toJS();

        default:
            return state.toJS();
    }
}